<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="协会名称">
          <el-input placeholder="请输入协会名称" v-model="formInline.search">
        
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加协会</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
      
            <el-table-column prop="name" label="协会名称"></el-table-column>
             <el-table-column prop="contacts" label="联系人"></el-table-column>
              <el-table-column prop="phone" label="联系人电话"></el-table-column>
              
               <el-table-column prop="email" label="邮箱"></el-table-column>
               <el-table-column prop="ht_id" label="后台账号"></el-table-column>
               <el-table-column label="审核状态" width="100">
                            <template slot-scope="scope">
                                <span class="status-tag" :class="'status-' + scope.row.status">
                                    {{ getStatusText(scope.row.status) }}
                                </span>
                            </template>
                        </el-table-column>

            <el-table-column prop="sort" label="排序" ></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
             <el-table-column fixed="right" label="操作" width="180">
                            <template slot-scope="scope">
                                <div class="action-buttons">
                                      <el-button 
                                        v-if="scope.row.status === 0" 
                                        @click="approveClick(scope.row)" 
                                        type="text" 
                                        size="small"
                                        style="color: #67c23a;"
                                    >通过</el-button>
                                    <el-button 
                                        v-if="scope.row.status === 0" 
                                        @click="rejectClick(scope.row)" 
                                        type="text" 
                                        size="small"
                                        style="color: #f56c6c;"
                                    >拒绝</el-button>
                                    <!-- <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button> -->
                                    <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                                  
                                </div>
                            </template>
                        </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :core_members_id="core_members_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible' 
    :close-on-click-modal="false" 
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>
  
  </div>
</template>

<script>
  import SettledApi from '@/api/settled.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        core_members_id:"",
        dialogVisible:false,
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//协会标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
       getStatusText(status) {
                    const statusMap = {
                        0: '未审核',
                        1: '已通过',
                        2: '已拒绝'
                    };
                    return statusMap[status] || '未知';
                },

                approveClick(row) {
    this.$confirm(`确认通过协会"${row.name}"的申请?`, '审核通过', {
        confirmButtonText: '通过',
        cancelButtonText: '取消',
        type: 'success'
    }).then(() => {
        row.status = 1;
        SettledApi.auditXiehuix({'xiehui_id': row.xiehui_id, 'status': 1}).then((res) => {
            this.$message({
                type: 'success',
                message: '已通过申请!'
            });
        }).catch(error => {
            // 如果API调用失败，恢复原来的状态
            row.status = 0;
            this.$message.error('操作失败，请重试');
        });
    }).catch(() => {
        // 用户取消操作
    });
},
                rejectClick(row) {
                    this.$confirm(`确认拒绝协会"${row.name}"的申请?`, '审核拒绝', {
                        confirmButtonText: '拒绝',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        row.status = 2;
                         SettledApi.auditXiehuix({'xiehui_id':row.xiehui_id,'status':2}).then(res => {
this.$message({
                            type: 'success',
                            message: '已通过申请!'
                        });
                        })
                    }).catch(() => {});
                },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        SettledApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.core_members_id = row.core_members_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            SettledApi.del(
              {
                core_members_id: row.core_members_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/enterprise/settled/settled.vue